module.exports = __webpack_public_path__ + "img/android_nfc_success.a830bb48.svg";